import { logAuth } from './auth-debug-logger';

const SESSION_KEY = 'sg:signInPageBackendSignIn';

export function markSignInPageBackendSignInFlow(): void {
  if (typeof sessionStorage === 'undefined') {
    logAuth('signInPageFlow:markSkipped', { reason: 'noSessionStorage' });
    return;
  }
  sessionStorage.setItem(SESSION_KEY, '1');
  logAuth('signInPageFlow:mark');
}

/** Read without clearing — retries / multiple signIn attempts in one sync must see the same value. */
export function peekSignInPageBackendSignInFlow(): boolean {
  if (typeof sessionStorage === 'undefined') {
    return false;
  }
  const active = sessionStorage.getItem(SESSION_KEY) === '1';
  logAuth('signInPageFlow:peek', { active });
  return active;
}

export function clearSignInPageBackendSignInFlow(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(SESSION_KEY);
  logAuth('signInPageFlow:clear');
}
